<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content
  style="min-width: 300px; min-height: 450px; width: 100%;">
      <div style="width: 100%; margin-top: 21px;">
        <input #ebbFileInput name="ebbFileInput"
          style="display: none;"
          type="file" aria-hidden="true" title="file"
          name="ebbFileInput"
          class="form-control"
          ngModel
          onclick="this.value=null"
          (change)="ebbFileInputChange($event)"/>
      </div>
      <div style="margin-top: -18px !important; width: 100%;">
        <button mat-flat-button color="accent"
          style="float: left; min-width:135px;"
          (click)="ebbFileInput.click()">
          BROWSE FOR FILE
        </button>
      </div>


      <div  style="width: 100%; display: block; float: left;">
        <p *ngIf="!fileError">{{displayFileName}}</p>
        <p *ngIf="fileError" class="mat-error"><mat-icon>warning</mat-icon> {{displayFileName}}</p>
      </div>
      <div style="width: 100%; display: block; float: left;">
        <div *ngIf="!validFileSelected" style="color: #727272; margin-top: 10px;">
          <p>Only the following file types can be uploaded:</p>
          <ul>
            <li>Adobe PDF</li>
            <li>Microsoft Word DOCX</li>
            <li>Image JPG</li>
            <li>Image PNG</li>
            <li>Video MP4</li>
          </ul>
          <p>The maximum file size is {{fileMaxSize}}MB.</p>
        </div>
      </div>
      <div *ngIf="validFileSelected" style="clear: both;">
        File: {{displayFileName}}
        <div style="margin-top: 18px;">
          <form [formGroup]="formFileAttributes" autocomplete="nope">
            <mat-form-field
              appearance="outline"
              style="width: 100%;">
              <mat-label>File Type</mat-label>
              <select matNativeControl
                id="fileType"
                name="fileType"
                formControlName="fileType">
                  <option value=''>-- Select Type --</option>
                  <option value='700000000'>Report</option>
                  <option value='700000001'>Photo</option>
                  <option value='700000002'>Video</option>
                  <option value='700000003'>Letter</option>
                  <option value='700000004'>Other</option>
              </select>
              <mat-error
                *ngIf="onCheckFileAttributesControlValidators('fileType')">
                File type required
              </mat-error>
            </mat-form-field>
          </form>
        </div>
        <div>
          <img [src]="attachmentBase64" style="height: 200px; overflow: scroll;" alt="uploaded file"/>
        </div>
    </div>
  <div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
    <button mat-button
      (click)="onClickCancel()">
      CANCEL
    </button>
    <button mat-flat-button
      (click)="onClickSave()"
      color="primary"
      [disabled]="(formFileAttributes.pristine || formFileAttributes.invalid)">
      SAVE
    </button>
  </div>
</div>
